import { ColorCircularProgress } from 'components/common/ColorCircularProgress/ColorCircularProgress'

export default ColorCircularProgress
